import React from 'react';
import { Link } from 'react-router-dom';
import OnePageMenu from './OnePageMenu';
import SearchIcon from './SearchIcon';
import SideBar from './SideBar';
import { useEffect } from 'react';
import OnePageSideBar from './OnepageSidebar';

export default function HeaderTwo(){	
	useEffect(() => {
        window.addEventListener('scroll', isSticky);
        return () => {
            window.removeEventListener('scroll', isSticky);
        };
    });           
    /* Method that will fix header after a specific scrollable */
	const isSticky = (e) => {
		const header = document.querySelector('.main-header-area');
		const scrollTop = window.scrollY;
		scrollTop >= 250 ? header.classList.add('sticky-menu') : header.classList.remove('sticky-menu');
	};
	const openSideBar = () =>{
		document.body.classList.add('on-side');
		document.offcanvas.classList.add('show');
	}
	const SideBarRemove = () => {
        document.body.classList.remove('on-side');
    };	
    return(
        <>
		<div className="body-overlay activemode"></div>
		<OnePageSideBar/>
            <header id="home" className="header-style-2">
			<div className="advertisement-text heding-bg2">
				<div className="container">
					<div className="row">
						<div className="col-xl-12 text-center">
							<span>Now Hiring: Are you a driven and motivated 1st Line IT Support Engineer?</span>
						</div>
					</div>
				</div>
			</div>
			<div className="container d-none d-sm-block">
				<div className="row align-items-center pt-15 pb-15">
					<div className="col-xl-8 col-lg-9">
						<ul className="right-query right-query2 list-none">
							<li>
								<div className="icon"><i className="fas fa-phone"></i></div>
								<div className="query-list">
									<span>Phone Number</span> <br />
									<a href="#" className="text-heding">890. 908. 645. 45</a>
								</div>
							</li>
							<li>
								<div className="icon ic-2"><i className="fas fa-envelope"></i></div>
								<div className="query-list">
									<span>Email Address</span> <br />
									<a href="#" className="text-heding">info@webmail.com</a>
								</div>
							</li>
							<li>
								<div className="logo-area pl-70">
									<Link className="head-logo-1" to="/"><img src="assets/img/logo/header-logo-2.png"
											alt="Header-logo" /></Link>
								</div>
							</li>
						</ul>
					</div>
					<div className="col-xl-4 col-lg-3 text-end d-none d-lg-inline-block">
						<a className="theme_btn quote-btn2" href="contact.html">Free Consultation</a>
					</div>
				</div>
			</div>
			<div className="main-header-area theme-gradient-bg2">
				<div className="container">
					<div className="row align-items-center">
						<div className="col-lg-2 col-6">
							<div className="hamburger-menu hamburger-2">
								<a  onClick={openSideBar}>
									<img src="assets/img/icon/bar-1.png" alt="Eclips" />
								</a>
							</div>
						</div>
						<div className="col-lg-8 d-none d-lg-block">
							<div className="menu-style-2">
								<OnePageMenu/>
							</div>
						</div>
						<div className="col-lg-2 col-6 text-end">
							<div className="search-area search-area2">
								<SearchIcon/>
							</div>
						</div>
					</div>
				</div>
			</div>
			
		</header>
        </>
    )
}